export default __webpack_public_path__ + "static/media/autoupdate.202e7714.svg";